import { render, staticRenderFns } from "./profile-information.vue?vue&type=template&id=84cdee38&scoped=true"
import script from "./profile-information.vue?vue&type=script&lang=js"
export * from "./profile-information.vue?vue&type=script&lang=js"
import style0 from "./profile-information.vue?vue&type=style&index=0&id=84cdee38&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cdee38",
  null
  
)

export default component.exports